/** @file mirrorPairOf: what the mirror-pair row of a node menu offers (pair, unpair, or why not). */
import type { EditorStore } from '../../state/editorTypes';

/** The row: its label, the twin to pair with (null = unpair), and whether it can act. */
export type MirrorPair = { label: string; twin: string | null; enabled: boolean };

/** Pair with the other selected node, unpair the current twin, or a disabled hint to Shift+click the twin first. */
export function mirrorPairOf(store: EditorStore, name: string): MirrorPair {
  const s = store.getState();
  const twin = s.puppet.doc?.puppet.nodes[name]?.mirror;
  const other = s.selection.nodes.find((n) => n !== name);
  if (other !== undefined) return { label: `Mirror pair with ${other}`, twin: other, enabled: true };
  if (twin !== undefined) return { label: `Unpair mirror (${twin})`, twin: null, enabled: true };
  return { label: 'Mirror pair with... (Ctrl+click the twin first)', twin: null, enabled: false };
}
